import { Component, Vue } from 'vue-property-decorator'
import CAAG1110Service from './CAAG1110Service'
import CAAG1110ViewModel from './CAAG1110ViewModel'
import TransportService from '@/common/TransportService'
import CommonConstants from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import { FormatConstants } from '@/common/FormatConstants'
import { fixedContent } from '@/assets/js/main.js'
import CommonUtil from '@/common/utils/CommonUtil'
@Component({
  name: 'CAAG1110',
  components: {}
  })
export default class CAAG1110Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private FormatConstants = FormatConstants
  private isDisPlayContent = false
  private caag1110Service = new CAAG1110Service()
  private caag1110ViewModel: CAAG1110ViewModel = {
    unreadCount: null,
    newsDtlLgnAfterInfo: {
      titl: '',
      information: '',
      postDay: '',
      report1Name: '',
      report1Url: '',
      report2Name: '',
      report2Url: '',
      report3Name: '',
      report3Url: ''
    }
  }

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    this.$root.$emit('renderHeader', '')
  }

  /**
   * 初期処理
   */
  private async init() {
    const id = Number(JSON.parse(JSON.stringify(this.$route.query.id || '')))
    const params = `id=${id}`
    const [
      caaa1110ResponseModel,
      transportResponseModel
    ] = await Promise.all([
      this.caag1110Service.callAPICAAA1110(id),
      // 稼働／閲覧統計ログを実行する
      TransportService.callAPITransportWithLogMode(CommonConstants.URL_CAAG1110, null, params, CommonConstants.LOG_MODE_ACCESS_ONLY)
    ])

    const userInfo = JSON.parse(
      SessionStorageService.getItem(CommonConstants.USER_INFO)
    )
    userInfo.userInfo.unreadCount = caaa1110ResponseModel.unreadCount
    SessionStorageService.setItem(
      CommonConstants.USER_INFO,
      JSON.stringify(userInfo)
    )

    this.caag1110ViewModel.unreadCount = caaa1110ResponseModel.unreadCount

    if (CommonUtil.isNotEmpty(caaa1110ResponseModel.newsDtlLgnAfterInfo)) {
      this.isDisPlayContent = true
      this.caag1110ViewModel.newsDtlLgnAfterInfo =
        caaa1110ResponseModel.newsDtlLgnAfterInfo

      this.caag1110ViewModel.newsDtlLgnAfterInfo.information =
        this.caag1110ViewModel.newsDtlLgnAfterInfo?.information?.replaceAll(
          CommonConstants.REGEX_LINE_BREAK,
          '<br/>'
        )
    }
  }

  /**
   * PDFファイルを別タブで開く。
   * @param pdfFilePath
   */
  private async openPDF(pdfFilePath) {
    window.open(pdfFilePath, '_blank')
  }

  /**
   * 「お知らせ一覧（ログイン後）」（CAAG1100）画面に遷移する。
   */
  private gotoCAAG1100() {
    this.$router.push({ name: 'caag1100', params: {} })
  }
}
